
import * as React from 'react';
import { Button, Typography } from '@material-ui/core';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import * as ReactDOM from 'react-dom';

// @ts-ignore
const createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

// 画像の最大幅
const MAX_WIDTH = 2000;

interface OwnProps {
  color: "default" | "inherit" | "primary" | "secondary" | undefined;
  onFileSelected: (imageAsObjectUrl: string) => void;
}

class SelectPicture extends React.Component<OwnProps>{
  private fileNode;
  // private img;
  // ファイルを選択された時のイベント
  _fileSelected({ target }) {
    // 何も選択されなかった場合は空文字として終了
    if (!target.files[0]) {
      this.props.onFileSelected('');
      return;
    }
    const file = target.files[0];
    // 画像以外の場合は空文字として終了
    if (!file || !file.type || !file.type.includes('image')) {
      this.props.onFileSelected('');
      return;
    }
    const reader = new FileReader();
    // 画像ファイルが読み込まれたら実行される
    const imageLoaded = (e) => {
      // 画像をObjectUrlにしてイベントを発火
      const imgeObjectUrl = createObjectURL(file);
      // this.props.onFileSelected(imgeObjectUrl);

      this.resizeImage({ srcImage: imgeObjectUrl })
        .then(resizedData => this.props.onFileSelected(resizedData));

    };
    // Fileの読み込みが完了したらimageLoaded()を呼び出す
    reader.onload = ((e) => {
      return imageLoaded;
    })(file);

    // 読み込みを実行
    reader.readAsDataURL(file);
  }

  resizeImage({srcImage}): Promise<string> {
    return new Promise((resolve) => {
      // Image Type
      const imgType = srcImage.substring(5, srcImage.indexOf(";"));
      // Source Image
      const img = new Image();
      img.onload = () => {
          // オリジナル画像のサイズ
          const originalHeight = img.height;
          const originalWidth = img.width;

          // 結果の画像サイズ
          let width = originalWidth;
          let height = originalHeight;

          // オリジナル画像の幅が最大幅を超えている場合、縦横比を維持したまま縮小する
          if (width > MAX_WIDTH) {
            // 縮尺
            const ratio = MAX_WIDTH / width;
            width = width * ratio;
            height = height * ratio;
          }

          console.log('originalWidth x originalHeight', `${originalWidth} x ${originalHeight}`);
          console.log('width x height', `${width} x ${height}`);
          // New Canvas
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          // Draw (Resize)
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0, width, height);
            // Destination Image
            const imgB64Dst = canvas.toDataURL(imgType);
            resolve(imgB64Dst);
          }
          resolve('');
      };
      img.src = srcImage;
      // this.img.src = srcImage;
    });
  }

  render() {
    return (
    <div>
      <input
        type="file"
        ref={(r) => {
          if (r) {
            this.fileNode = ReactDOM.findDOMNode(r);
          }
        }}
        style={{ display: 'none' }}
        accept="image/*;capture=camera"
        onChange={(e) => this._fileSelected(e)}
      />
      <Button
        variant="contained"
        color={this.props.color}
        fullWidth
        onClick={() => this.fileNode.click()}
      >
        <PhotoCamera/>
      </Button>
      {/* <img ref={(r) => {
        if (r) {
          this.img = r;
        }
      }}/> */}
      <Typography variant="body2"  style={{ marginTop: '5px' }}>
        写真を撮影できない場合は設定画面からご利用のアプリケーション（Chrome/Safari）からカメラのアクセス許可をONにしてください。
      </Typography>
    </div>
    );
  }
}

export default SelectPicture;



// WEBPACK FOOTER //
// ./src/components/SelectPicture.tsx